import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

/** Deep-link cũ `/…/edit/:id` → `/…/list?editId=` (modal trên list). */
export function EditIdListRedirect({ listPath }: { listPath: string }) {
  const { id } = useParams<{ id: string }>()
  const q = id ? `?editId=${encodeURIComponent(id)}` : ''
  return <Navigate to={`${listPath}${q}`} replace />
}

/** Deep-link cũ `/…/detail/:id` → `/…/list?detailId=` (modal xem). */
export function DetailIdListRedirect({ listPath }: { listPath: string }) {
  const { id } = useParams<{ id: string }>()
  const q = id ? `?detailId=${encodeURIComponent(id)}` : ''
  return <Navigate to={`${listPath}${q}`} replace />
}

export function lazyEditIdListRedirect(listPath: string) {
  return React.lazy(async () => ({
    default: function EditIdRedirectRoute() {
      return <EditIdListRedirect listPath={listPath} />
    },
  }))
}

export function lazyDetailIdListRedirect(listPath: string) {
  return React.lazy(async () => ({
    default: function DetailIdRedirectRoute() {
      return <DetailIdListRedirect listPath={listPath} />
    },
  }))
}

export default EditIdListRedirect
